// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function argsToString(args, exprToStr) {
  return args.map(function (arg, i) {
                return String(i + 1 | 0) + ": " + (
                        arg.length === 0 ? "?" : exprToStr(arg)
                      );
              }).join("\n");
}

function unifErrToStr(err, exprToStr, frmExprToStr) {
  if (typeof err !== "object") {
    return "Details of the error were not stored.";
  }
  switch (err.TAG) {
    case "DisjCommonVar" :
        var arrow = String.fromCharCode(8594);
        return "Unsatisfied disjoint, common variable " + exprToStr([err.commonVar]) + ":\n" + (frmExprToStr([err.frmVar1]) + " " + arrow + " " + exprToStr(err.expr1) + "\n") + (frmExprToStr([err.frmVar2]) + " " + arrow + " " + exprToStr(err.expr2));
    case "Disj" :
        var arrow$1 = String.fromCharCode(8594);
        return "Missing disjoint " + exprToStr([err.var1]) + "," + exprToStr([err.var2]) + ":\n" + (frmExprToStr([err.frmVar1]) + " " + arrow$1 + " " + exprToStr(err.expr1) + "\n") + (frmExprToStr([err.frmVar2]) + " " + arrow$1 + " " + exprToStr(err.expr2));
    case "UnprovedFloating" :
        return "Could not prove this floating statement:\n" + exprToStr(err.expr);
    case "NoUnifForAsrt" :
        var arrow$2 = String.fromCharCode(8594);
        return "Could not find a match for assertion:\n" + (frmExprToStr(err.asrtExpr) + "\n" + arrow$2 + "\n" + exprToStr(err.expr));
    case "NoUnifForArg" :
        var args = err.args;
        var colon = args.length === 0 ? "" : ":";
        return "Could not match essential hypothesis #" + String(err.errArgIdx + 1 | 0) + colon + "\n" + argsToString(args, exprToStr);
    case "NewVarsAreDisabled" :
        var errArgIdx = err.errArgIdx;
        var args$1 = err.args;
        var what = args$1.length === errArgIdx ? "assertion" : "essential hypothesis #" + String(errArgIdx + 1 | 0);
        var colon$1 = args$1.length === 0 ? "" : ":";
        return "New variables are not allowed, but one had to be created" + (" when unifying " + what + colon$1 + "\n") + argsToString(args$1, exprToStr);
    case "TooManyCombinations" :
        var frmLabels = err.frmLabels;
        if (frmLabels !== undefined) {
          return "Some assertions produce too big search space. Only part of that search space was examined. Those assertions are: " + frmLabels.join(", ") + " .";
        } else {
          return "This assertion produces too big search space. Only part of that search space was examined.";
        }
    
  }
}

exports.unifErrToStr = unifErrToStr;
/* No side effect */
